module.exports = __webpack_public_path__ + "img/qr.9bdc7cad.png";